import type { UserRole } from './auth';
import type { ModuleEntry } from './module-registry';

/**
 * Role hierarchy levels — higher number means more access.
 * admin ≥ user ≥ read-only
 */
const ROLE_LEVEL: Record<UserRole, number> = {
  'admin': 3,
  'user': 2,
  'read-only': 1,
};

/**
 * Returns true if `userRole` has sufficient access for `requiredRole`.
 */
export function hasAccess(userRole: UserRole, requiredRole: UserRole): boolean {
  return ROLE_LEVEL[userRole] >= ROLE_LEVEL[requiredRole];
}

/**
 * Filters module entries to only those the given role is permitted to access.
 */
export function filterModulesByRole(
  entries: ModuleEntry[],
  userRole: UserRole,
): ModuleEntry[] {
  return entries.filter((entry) => hasAccess(userRole, entry.requiredRole));
}
